module.exports = __webpack_public_path__ + "img/fallback-slide.2560x1280.en.dc4c0728.png";